import "./WorkCardStyles.css";
import WorkCard from "./WorkCard";
import React from "react";
import WorkCardData from "./WorkCardData";

const Work = () => {
  return (
    <div className="work-container">
      <h1 className="project-heading">Proyectos</h1>
      <div className="project-container">
        {WorkCardData.map((val, ind) => {
          return (
            <WorkCard
              key={ind}
              imgsrc={val.imgsrc}
              title={val.title}
              text={val.text}
              github={val.github}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Work;
